'use client';
import React, { useState } from 'react';
import AnimatedGradientButton from '../shared/AnimatedGradientButton';

const SubscribeWidget = () => {
  const [_isMounted, _setIsMounted] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    setIsError(false);

    try {
      const res = await fetch('/api/subscribe', {
        body: JSON.stringify({ email }),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
      });

      if (!res.ok) throw new Error('Subscribe failed');

      setMessage('Thank you for subscribing!');
      setEmail('');

      // Auto-clear message after 5 seconds
      setTimeout(() => {
        setMessage('');
        setIsError(false);
      }, 5000);
    } catch (_error) {
      setIsError(true);
      setMessage('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full max-w-[600px]">
      <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-3">
        <div className="relative min-w-[250px] flex-1">
          <label
            htmlFor="email"
            className="mb-1 block font-['Karla'] text-base"
          >
            Email<span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="e.g., email@example.com"
            className="h-[59px] w-full border-0 border-b-2 border-black p-0 font-['Karla'] text-base transition-colors duration-200 focus:border-b-3 focus:border-orange-500 focus:outline-none"
            required
          />
        </div>
        <div className="flex items-end">
          <AnimatedGradientButton
            flatHover={true}
            text={isSubmitting ? 'Subscribing...' : 'Subscribe'}
            as="button"
            type="submit"
            disabled={isSubmitting}
            theme="orange"
            className="h-[59px] min-w-[180px]"
          />
        </div>
      </form>

      {message && (
        <div
          className={`mt-2 font-['Work_Sans'] text-base font-medium ${isError ? 'text-red-500' : 'text-green-600'}`}
        >
          {message}
        </div>
      )}

      <style jsx>{`
        @media (max-width: 515px) {
          .flex-1 {
            width: 100%;
            margin-bottom: 20px !important;
          }

          .flex.items-end {
            width: 100%;
            margin-top: 8px;
          }
        }
      `}</style>
    </div>
  );
};

export default SubscribeWidget;
